import React from 'react';

function WapModal({ title = '', body ='', buttons = [], handleClick ,messageCode = ''}) {
  return (
    <div className="fixed text-white inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-50">
      <div className="bg-darkPurple w-3/4 pb-6 md:w-1/3 lg:w-1/3 sm:w-1/2 p-5 rounded-lg shadow-lg relative z-50 flex flex-col items-center">
        <div className="flex justify-between items-center w-full mb-4">
          {/* <h2 className="text-xl font-semibold text-center w-full">{title}</h2> */}
        </div>
        <div className="mb-4 text-center">
          <p>{body}</p>
        </div>
        <div className="flex justify-center space-x-2">
          {buttons.map((button, index) => (
            <button
              key={index}
              onClick={()=> handleClick(button.action)}
              className="px-4 py-2 bg-buttonYellow text-darkPurple font-bold rounded"
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WapModal;
